import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedLongTermMedications = (patientId, page = 1, search = "", rows = 5) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["paginatedLongTermMedications", patientId, tenantVal, page, search, rows],
    queryFn: async () => {
      if (!patientId) return null;
      
      const axiosInstance = createAxiosInstance();
      
      try {
        const response = await axiosInstance.get(
          `${tenantVal}/patientmedication/groupedbypatientidandtype/${patientId}/LONGTERM/page`,
          {
            params: {
              page,
              rows,
              search: search.length >= 3 ? search : undefined
            }
          }
        );
        
        return response.data;
      } catch (error) {
        console.warn("Paginated Long Term medications endpoint not available, using fallback:", error.response?.status);

        const fallbackResponse = await axiosInstance.get(
          `${tenantVal}/patientmedication/groupedbypatientidandtype/${patientId}/LONGTERM`
        );

        let allData = fallbackResponse.data || [];

        if (search && search.length >= 3) {
          allData = allData.filter(item => {
            const medicationName = item.tradeName?.toLowerCase() || "";
            const genericName = item.genericName?.toLowerCase() || "";
            const searchLower = search.toLowerCase();
            return medicationName.includes(searchLower) || genericName.includes(searchLower);
          });
        }
        
        const startIndex = (page - 1) * rows;
        const endIndex = startIndex + rows;
        const paginatedData = allData.slice(startIndex, endIndex);
        
        return {
          data: paginatedData,
          totalRecords: allData.length,
          currentPage: page
        };
      }
    },
    enabled: !!patientId,
  });
};